var cx = require("classnames");

var UserAvatar = React.createClass({
  propTypes: {
    avatarURL: React.PropTypes.string,
    name: React.PropTypes.string,
    className: React.PropTypes.string,
    size: React.PropTypes.oneOf(["big", "small"]),
    alt: React.PropTypes.string
  },
  getDefaultProps: function() {
    return {
      avatarURL: "",
      name: "",
      size: "big",
      addTitle: true
    };
  },
  getInitialState: function() {
    return ({ imgLoad: null });
  },
  getInitialLetters: function() {
    var letters = "";
    var words = this.props.name.split(" ");
    if (words.length == 1) {
      letters = words[0].substring(0, 3).toUpperCase();
    } else if (words.length == 2) {
      letters += words[0].substring(0, 2).toUpperCase();
      letters += words[1].substring(0, 1).toUpperCase();
    } else {
      letters += words[0].substring(0, 1).toUpperCase();
      letters += words[1].substring(0, 1).toUpperCase();
      letters += words[2].substring(0, 1).toUpperCase();
    }

    return letters;
  },
  getTitle: function() {
    if (this.props.addTitle) {
      return this.props.name;
    }
  },
  render: function () {
    let image = new Image();
    image.title = this.getTitle();

    if (this.props.avatarURL) {
      image.src = this.props.avatarURL;
    }

    if (!this.state.imgLoad) {
      image.onload = () => {
        this.setState({ imgLoad: 'success' });
      };

      image.onerror = () => {
        this.setState({ imgLoad: 'error' });
      };
    }

    let userAvatarClass;

    if(this.props.size == "big") {
      userAvatarClass = "userAvatar";
    } else if(this.props.size == "small") {
      userAvatarClass = "userAvatar--small ta-c";
    }

    let classes = cx(userAvatarClass, this.props.className, "ovf-h", "p-r");
    let initials = this.getInitialLetters();

    if (this.state.imgLoad !== 'success') {
      return <div className={classes} content={initials} />
    }

    return (
      <div className={classes}>
        <img
          src={image.src}
          title={image.title}
          alt=""
        />
      </div>
    );
  }
});

module.exports = UserAvatar;



// WEBPACK FOOTER //
// ./app/shared/components/User/user-avatar.jsx